const textToHalfWidth = char =>
        char.replace(/[\uff01-\uff5e]/g, i =>
            String.fromCharCode(i.charCodeAt(0) - 0xfee0)
        );
export default textToHalfWidth


// WEBPACK FOOTER //
// ./src/dev/validation/textToHalfWidth.js